<template>
  <div class="box-order-section">
    <mpn-section-title>배송정보</mpn-section-title>
    <!-- S : 배송정보 -->
    <div class="address-choice-item v2">
      <div class="address-item-a">
        <div class="address-tit">
          <p class="address-item-tit">
            주문번호
          </p>
        </div>
        <div class="address-item-content">
          <template v-if="orderResult.group === 'Y'">
          <p class="address-text-item" v-for="(order, index) in hybrisOrderKeys" :key="index">
            {{ order }}
          </p>
          </template>
          <template v-else>
          <p class="address-text-item">
            {{ orderResult.order_no }}
          </p>
          </template>
        </div>
      </div>
      <div class="address-item-a">
        <div class="address-tit">
          <p class="address-item-tit">
            주문일
          </p>
        </div>
        <div class="address-item-content">
          <p class="address-text-item">
            {{ orderResult.order_date }}
          </p>
        </div>
      </div>
      <div class="address-item-a">
        <div class="address-tit">
          <p class="address-item-tit">
            배송방법
          </p>
        </div>
        <div class="address-item-content">
          <p class="address-text-item">
            {{ receiptWay }}
          </p>
        </div>
      </div>
      <div
        v-if="deliveryWay"
        class="address-item-a"
      >
        <div class="address-tit">
          <p class="address-item-tit">
            픽업장소
          </p>
        </div>
        <div class="address-item-content">
          <p class="address-text-item">
            {{ orderResult.address }}
          </p>
        </div>
      </div>
      <div
        v-if="!deliveryWay"
        class="address-item-a"
      >
        <div class="address-tit">
          <p class="address-item-tit">
            배송지주소
          </p>
        </div>
        <div class="address-item-content">
          <p class="address-text-item">
            받는분 : {{ orderResult.delivery.name }}
          </p>
          <p class="address-text-item">
            [{{ aboAddress.postalCode }}] {{ aboAddress.address }}
          </p>
          <p class="address-text-item">
            연락처 : {{ formattedMobileNumber }}
          </p>
        </div>
      </div>
      <div class="address-item-a">
        <div class="address-tit">
          <p class="address-item-tit">
            결제수단
          </p>
        </div>
        <div class="address-item-content">
          <p class="address-text-item">
            {{ paymentMethod }}
          </p>
        </div>
      </div>
      <!-- <ul class="dot-list-a top_line">
        <li>배송지 변경은 <span class="pot-basic">쇼핑 &gt; 나의 쇼핑정보 &gt; 나의 주문내역 &gt; <a href="#">주문상세정보</a></span> 에서 하실 수 있습니다.</li>
      </ul> -->
    </div>
    <!-- E : 배송정보 -->
  </div>
</template>

<script>
import { parseMobileNumber } from '@/utils/common';
import { NORMAL_PAYMENT_METHODS, AMWAY_PAY_METHODS } from '@/utils/constants';

export default {
  name: 'DeliveryInfo',
  props: {
    orderResult: {
      type: Object,
      default: null,
    },
    hybrisOrderKeys: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    receiptWay() {
      return this.orderResult.cfm_kind !== 'VCALL' ? '픽업' : '배달';
    },
    aboAddress() {
      return {
        postalCode: this.orderResult.delivery.postalCode,
        address: this.orderResult.delivery.address,
      };
    },
    formattedMobileNumber() {
      const arr = parseMobileNumber(this.orderResult.delivery.cellphone);
      return arr.join('-');
    },
    deliveryWay() {
      if (this.orderResult.cfm_kind !== 'VCALL') {
        return true;
      }
      return false;
    },
    paymentMethod() {
      if (this.orderResult.paymentMethod === NORMAL_PAYMENT_METHODS.TRANSFER) {
        return '자동이체';
      } else if (this.orderResult.paymentMethod === NORMAL_PAYMENT_METHODS.CREDIT_CARD) {
        return '신용카드';
      } else if (this.orderResult.paymentMethod === AMWAY_PAY_METHODS.QUICK_ACCOUNT) {
        return "퀵계좌이체";
      } else if (this.orderResult.paymentMethod === AMWAY_PAY_METHODS.ACCOUNT) {
        return "A Pay 자동이체";
      } else {
        return "A Pay 신용카드";
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order/complete/partial/DeliveryInfo.vue